import { Injectable } from "@angular/core"
import { BroadcastApiService } from "@api/broadcast/broadcast-api.service"
import { RequestLogBody } from "@api/broadcast/models/log"

@Injectable({
  providedIn: "root",
})
export class LogService {
  constructor(private broadcastService: BroadcastApiService) {}

  logInformation(message: string, metric: any, identifier?: string): void {
    var user = JSON.parse(localStorage.getItem("user"))
    var log: RequestLogBody = {
      Message: `FE_Flow: ${message}`,
      Metrics: metric,
      OS: "Web/Flow",
      Level: "Information",
      UserId: identifier, //Anything that is usefull
      DeviceId: user?.FirstName + " " + user?.LastName + " " + user?.Email,
    }
    this.broadcastService.Log.postLog(log).subscribe(
      (response) => {},
      (error) => {
        console.error("Error logging", error)
      }
    )
  }

  logError(message: string, metric: any, identifier?: string): void {
    var user = JSON.parse(localStorage.getItem("user"))
    var log: RequestLogBody = {
      Message: `FE_Flow: ${message}`,
      Metrics: metric,
      OS: "Web/Flow",
      Level: "Error",
      UserId: identifier, //Anything that is usefull
      DeviceId: user?.FirstName + " " + user?.LastName + " " + user?.Email,
    }

    this.broadcastService.Log.postLog(log).subscribe(
      (response) => {},
      (error) => {
        console.error("Error logging", error)
      }
    )
  }

  logAnonymousError(message: string, metric: any): void {
    var log: RequestLogBody = {
      Message: `FE_Flow: ${message}`,
      Metrics: metric,
      OS: "Web/Flow",
      Level: "Error",
    }

    this.broadcastService.Log.postLog(log).subscribe(
      (response) => {},
      (error) => {
        console.error("Error logging", error)
      }
    )
  }
}
